import axios from "axios";
import { baseUrl } from '../config/clientsConfig'

const SpinWheelService = {
  createBannerImageTemplate: (formData, banerfolder) =>
    axios.post(`${baseUrl}/sp-image-upload/${banerfolder}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  createSpinwheel: (spObj, gifts, createdUserDocId, modifiedUserDocId) =>
    axios.post(`${baseUrl}/sp-create`, {
      spObj,
      gifts,
      createdUserDocId,
      modifiedUserDocId,
    }),
  getSpinWheelDetail: () => axios.get(`${baseUrl}/sp-get`),

  getSpinWheelWonExcelList: (docId) => axios.get(`${baseUrl}/sp-won/${docId}`),
  getSpinWheelLostExcelList: (docId) =>
    axios.get(`${baseUrl}/sp-lost/${docId}`),
  changeStatusOfSpinWheel: (obj) =>
    axios.post(`${baseUrl}/sp-state-change`, obj),
  resetSpinWheel: (obj) => axios.post(`${baseUrl}/sp-reset`, obj),
  setSpinWheelLogo: (obj) => axios.post(`${baseUrl}/sp-general-info`, obj),
  getSpinWheelGeneralInfo: () => axios.get(`${baseUrl}/sp-general-info-get`),
  getSpinWheelInfoById: (docId) => axios.get(`${baseUrl}/sp-get-info/${docId}`),
  updateSpinWheel: (docId, spObj, gifts, modifiedUserDocId) =>
    axios.patch(`${baseUrl}/sp-update`, {
      docId,
      spObj,
      gifts,
      modifiedUserDocId,
    }),
};

export default SpinWheelService;
